import {motion} from 'framer-motion';
import {authAnimation} from '../../animations';

const Menu = () => {

    return (
        <motion.div
        layoutId="auth"
        key="menu"
        variants={authAnimation}
        initial="initial"
        animate="visible"
        exit="exit"
        className="menu">

            <div className="buttons">
                <a href="/" className="cursor button login">Start over</a>
                <a target="_blank" rel="noreferrer" className="button outline login" href="https://glos.ac.uk">Visit the UoG website <svg alt="External link icon" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path></svg></a>
            </div>
            <ul className="external_menu">
                <li>
                    <a href="https://glos.ac.uk/#cookies" target="_blank" rel="noreferrer">Privacy &amp; cookies</a>
                </li>
                <li>
                    <a href="https://glos.ac.uk/#accessibility" target="_blank" rel="noreferrer">Accessibility</a>
                </li>
                <li>
                    <a href="https://glos.ac.uk/#disclaimer" target="_blank" rel="noreferrer">Disclaimer</a>
                </li>
                <li>
                    <a href="https://glos.ac.uk/#sitemap" target="_blank" rel="noreferrer">Sitemap</a>
                </li>
                <li>
                    <a href="https://glos.ac.uk/#contct" target="_blank" rel="noreferrer">Contact</a>
                </li>
            </ul>

            <span className="meta">
                <p className="is-7">&copy; 2015-2020 University of Gloucestershire.</p>
                <p className="is-7">Company Registration Number 06023243. VAT Number GB 886 1439 87</p>
            </span>

        </motion.div>
    );
}

export default Menu;